import AgogisUserModelBase from '../_generated/modelBases/agogis-user-model-base';

export default class AgogisUserModel extends AgogisUserModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
